const ADD_LINK_BUTTON = "LinkButton";
const WEB_LINK = "WebLink";
const ANCHOR_LINK = "AnchorLink";
const LINK_PLUGIN_EDIT_BUTTON = "EditLinkButton";
const LINK_PLUGIN_REMOVE_BUTTON = "RemoveLinkButton";
const LINK_PLUGIN_WEB_LINK_BUTTON = "GoToLinkButton";
const LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON = "ScrollToAnchorButton";
export {
  ADD_LINK_BUTTON,
  ANCHOR_LINK,
  LINK_PLUGIN_EDIT_BUTTON,
  LINK_PLUGIN_REMOVE_BUTTON,
  LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON,
  LINK_PLUGIN_WEB_LINK_BUTTON,
  WEB_LINK
};
//# sourceMappingURL=dataHooks.js.map
